import { createBrowserHistory } from "history";

// Created on first use so importing this doesn't need a DOM (node tests).
let history = null;

function getHistory() {
  if (history === null) {
    history = createBrowserHistory();
  }
  return history;
}

const appHistory = /** @type {import("history").History} */ (
  new Proxy(
    {},
    {
      get: (_target, prop) => Reflect.get(getHistory(), prop),
      has: (_target, prop) => Reflect.has(getHistory(), prop),
    },
  )
);

export default appHistory;
